<template id="">
  <div>
    <div class="login">
      <h3>
        <img
          class="logo"
          src="@/img/logo.png"
          alt="インテリジェントヘルスケア ストレスチェックApp"
        />
      </h3>
      <h4 class="common-font">
        {{ $t("displayValue_Respondent.CHANGE_PW_ttl_screen") }}
      </h4>
      <div v-show="$store.state.common.sIsLoading" class="common-font">
        Loading...
      </div>
      <div v-show="!$store.state.common.sIsLoading" class="common-font">
        <div class="uk-flex uk-flex-center">
          <div class="uk-container">
            <div class="uk-text-center" uk-grid>
              <div class="uk-width-1-1">
                <div class="uk-margin">
                  <div style="text-align: left">
                    <label class="uk-form-label uk-text-muted">{{
                      $t("displayValue_Respondent.CHANGE_PW_lbl_pw_now")
                    }}</label>
                  </div>
                  <div class="uk-inline uk-width-1-1">
                    <input
                      class="uk-input"
                      :type="vInputType"
                      v-model="now_pw"
                    />
                    <button
                      v-if="now_pw"
                      class="uk-form-icon uk-form-icon-flip"
                      uk-icon="icon: close"
                      @click="now_pw = ''"
                      tabindex="-1"
                    ></button>
                  </div>
                </div>
              </div>
              <div class="uk-width-1-1">
                <div class="uk-margin">
                  <div style="text-align: left">
                    <label class="uk-form-label uk-text-muted">{{
                      $t("displayValue_Respondent.CHANGE_PW_lbl_pw_new")
                    }}</label>
                    <br />
                    <label class="uk-form-label uk-text-muted uk-text-small">
                      {{
                        $t(
                          "displayValue_Respondent.CHANGE_PW_guide_num_of_char"
                        )
                      }}
                    </label>
                  </div>
                  <div class="uk-inline uk-width-1-1">
                    <input
                      class="uk-input"
                      :type="vInputType"
                      v-model="new_pw"
                    />
                    <button
                      v-if="new_pw"
                      class="uk-form-icon uk-form-icon-flip"
                      uk-icon="icon: close"
                      @click="new_pw = ''"
                      tabindex="-1"
                    ></button>
                  </div>
                </div>
              </div>
              <div class="uk-width-1-1">
                <div class="uk-margin">
                  <div style="text-align: left">
                    <label class="uk-form-label uk-text-muted">{{
                      $t("displayValue_Respondent.CHANGE_PW_lbl_pw_new_re")
                    }}</label>
                  </div>
                  <div class="uk-inline uk-width-1-1">
                    <input
                      class="uk-input"
                      :type="vInputType"
                      v-model="conf_pw"
                    />
                    <button
                      v-if="conf_pw"
                      class="uk-form-icon uk-form-icon-flip"
                      uk-icon="icon: close"
                      @click="conf_pw = ''"
                      tabindex="-1"
                    ></button>
                  </div>
                  <button
                    type="button"
                    class="
                      uk-button
                      uk-button-small
                      uk-button-text
                      uk-margin-small-top
                      common-rounded
                    "
                    @click="doSwitchPassword"
                    tabindex="-1"
                  >
                    {{
                      $t("displayValue_Respondent.CHANGE_PW_guide_pw_switch")
                    }}
                  </button>
                </div>
              </div>
              <div class="uk-width-1-1">
                <div class="uk-margin uk-flex">
                  <button
                    class="
                      uk-button uk-button-secondary uk-width-1-2
                      common-rounded
                    "
                    type="button"
                    @click="$router.back()"
                  >
                    &lt;&nbsp;{{
                      $t("displayValue_Respondent.CHANGE_PW_btn_back")
                    }}
                  </button>

                  <button
                    :disabled="
                      $store.state.common.sServerProcessing ||
                      flgCanUpdate == false
                    "
                    class="
                      uk-button
                      uk-button-primary
                      uk-width-1-2
                      uk-margin-small-left
                      common-rounded
                    "
                    type="button"
                    @click="change_pw"
                  >
                    {{ $t("displayValue_Respondent.CHANGE_PW_btn_update") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="uk-margin-small-top uk-text-danger uk-text-bold">
          <div>{{ vDispMsgChangePwResult }}</div>
          <div>{{ vDispMsgPwDifferent }}</div>
        </div>

        <hr />
      </div>
    </div>
  </div>
  <!-- <h1>パスワード変更</h1>
  <table style="margin:auto;">
    <tr>
      <td><p style="">現在のパスワード:</p></td>
      <td><input type="password" name="" v-model="now_pw"></td>
    </tr>
    <tr>
      <td><p style="">新パスワード:</p></td>
      <td><input type="password" name="" v-model="new_pw"></td>
    </tr>
    <tr>
      <td><p style="">新パスワード(確認用):</p></td>
      <td><input type="password" name="" v-model="conf_pw"></td>
    </tr>
  </table>
  <div>
    <p style="color:red;" v-if="length_flg==false">文字数が短すぎます(4文字以上)</p>
    <br v-else/>
  </div>
  <button class="uk-button uk-button-default" disabled v-if="flg==false">変更</button>
  <button class="uk-button uk-button-primary" v-else @click="change_pw">変更</button> -->
</template>

<script type="text/javascript">
export default {
  data() {
    return {
      now_pw: null,
      new_pw: null,
      conf_pw: null,
      flg: false,
      length_flg: true,
      tmp: "",
      tmp1: "",
      vMessage: "",
      vInputType: "password",
      flgCanUpdate: false, // 更新可能か判定用
      vDispMsgChangePwResult: "", // パスワード変更結果メッセージ
      vDispMsgPwDifferent: "", // 新パスワードと確認用が異なるメッセージ
      vChangePwResult: 0,
    };
  },
  mounted() {
    // document.title = "パスワード変更";
    this.setLanguageSubProc();
  },
  methods: {
    doSwitchPassword() {
      if (this.vInputType == "password") {
        this.vInputType = "text";
      } else if (this.vInputType == "text") {
        this.vInputType = "password";
      }
    },
    change_pw() {
      // パスワード変更処理の判定用
      this.vChangePwResult = 0;

      this.length_flg = true;
      this.$store.commit("common/doStartServerProcess");
      let createHash = require("sha256-uint8array").createHash;
      this.tmp = createHash().update(this.now_pw).digest("hex");
      this.tmp1 = createHash().update(this.new_pw).digest("hex");
      this.$axios
        .post("/respondent/changepw", {
          alias_id: sessionStorage.getItem("storageAliasId"),
          email: sessionStorage.getItem("storageId"),
          now_pw: this.tmp,
          new_pw: this.tmp1,
        })
        .then((response) => {
          this.$store.commit("common/doEndServerProcess");
          if (response.data.return_result == 0) {
            this.vChangePwResult = 1;
            this.dispChangePwResult();
            alert(
              this.$t("displayValue_Respondent.CHANGE_PW_alert_changed_pw")
            );
          } else {
            this.vChangePwResult = 2;
            this.dispChangePwResult();
          }
        })
        .catch((error) => {
          console.log("エラー");
          console.log(error);
        });
      this.$store.commit("common/doEndServerProcess");
    },
    // 言語設定の補足処理
    setLanguageSubProc() {
      document.title = this.$t("displayValue_Respondent.CHANGE_PW_ttl_doc");
    },
    // 空白チェック
    checkInputBlank() {
      let _return = true; // true = OK

      // 現在のパスワード
      let _tmpNow_pw = this.removeBlank(this.now_pw);
      if (!_tmpNow_pw) {
        _return = false;
      }

      // 新パスワード
      let _tmpNew_pw = this.removeBlank(this.new_pw);
      if (!_tmpNew_pw) {
        _return = false;
      }

      // 新パスワード（確認用）
      let _tmpConf_pw = this.removeBlank(this.conf_pw);
      if (!_tmpConf_pw) {
        _return = false;
      }

      this.flgCanUpdate = _return;
    },
    // 空白除外
    removeBlank(pVal) {
      if (!pVal) {
        return;
      }
      let _return = pVal;
      _return = pVal.replace(/[\s\u3000]/g, "");
      return _return;
    },
    // 新パスワードの確認
    checkNewPw() {
      this.vDispMsgPwDifferent = "";
      let _return = true;

      // 新パスワード
      let _tmpNew_pw = this.removeBlank(this.new_pw);
      // 新パスワード（確認用）
      let _tmpConf_pw = this.removeBlank(this.conf_pw);

      // 両方空白の場合は更新不可
      if (!_tmpNew_pw && !_tmpConf_pw) {
        _return = false;
      }

      // 4文字未満の場合は更新不可
      let _lenNew_pw = _tmpNew_pw ? _tmpNew_pw.length : 0;
      let _lenConf_pw = _tmpConf_pw ? _tmpConf_pw.length : 0;
      if (_lenNew_pw < 4 && _lenConf_pw < 4) {
        _return = false;
      }

      // どちらかが0文字の場合は更新不可
      console.log("_lenNew_pw = ", _lenNew_pw);
      console.log("_lenConf_pw = ", _lenConf_pw);
      if (_lenNew_pw == 0 || _lenConf_pw == 0) {
        _return = false;
      }

      if (!_return) {
        this.flgCanUpdate = _return;
        return;
      }

      // パスワード比較
      if (_tmpNew_pw != _tmpConf_pw) {
        _return = false;
        this.vDispMsgPwDifferent = this.$t(
          "displayValue_Respondent.CHANGE_PW_msg_no_match_pw"
        );
      }
      this.flgCanUpdate = _return;
    },
    // パスワード変更処理の結果判定
    dispChangePwResult() {
      switch (this.vChangePwResult) {
        case 1:
          this.vDispMsgChangePwResult = this.$t(
            "displayValue_Respondent.CHANGE_PW_msg_changed_pw"
          );
          break;
        case 2:
          this.vDispMsgChangePwResult = this.$t(
            "displayValue_Respondent.CHANGE_PW_msg_failure_change_pw"
          );
          break;
        default:
          this.vDispMsgChangePwResult = "";
          break;
      }
    },
  },
  watch: {
    // 現在のパスワード
    now_pw(newVal) {
      this.vChangePwResult = 0;
      this.vDispMsgChangePwResult = "";
      this.checkInputBlank();
    },
    // 新パスワード
    new_pw(newVal) {
      this.vChangePwResult = 0;
      this.vDispMsgChangePwResult = "";
      this.checkInputBlank();
      this.checkNewPw();
    },
    //  パスワード（確認用）
    conf_pw(newVal) {
      this.vChangePwResult = 0;
      this.vDispMsgChangePwResult = "";
      this.checkInputBlank();
      this.checkNewPw();
    },
    // 選択した言語によって表示する値を変更する
    "$store.state.common.sLanguageTypeNow"(newVal, oldVal) {
      this.checkNewPw();
      this.dispChangePwResult();
    },
  },
};
</script>

<style scoped>
table tr td p {
  display: inline;
  text-align: right;
}
table tr td {
  text-align: right;
}
</style>
